export const getSafeHeliosFileCount = (currentCount: number | null | undefined, addedCount = 0, removedCount = 0) =>
  Math.max(0, (currentCount ?? 0) + addedCount - removedCount);
